
import { Component, Vue } from 'vue-property-decorator';
import BaseCabecalho from '@/components/base/BaseCabecalho.vue';
import Service from '@/services/relatorios.service';

@Component({
  components: {
    BaseCabecalho,
  },
})
export default class Relatorios extends Vue {
  public colapses = [];

  exportandoPontosGanhosPorIda = false;

  exportandoGeneros = false;

  exportandoTrocas = false;

  exportandoQtdProdutoPorLoja = false;

  gerarPontosGanhosPorIda() {
    this.exportandoPontosGanhosPorIda = true;
    Service.gerarPontosGanhosPorIda()
      .then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const linkElement = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('download', response.headers['content-disposition'].split('=')[1]);
        linkElement.setAttribute('href', url);
        document.body.appendChild(linkElement);
        linkElement.click();
        this.exportandoPontosGanhosPorIda = false;
      })
      .catch((error: any) => {
        this.exportandoPontosGanhosPorIda = false;
        console.error(error);
      });
  }

  gerarGeneros() {
    this.exportandoGeneros = true;
    Service.gerarGeneros()
      .then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const linkElement = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('download', response.headers['content-disposition'].split('=')[1]);
        linkElement.setAttribute('href', url);
        document.body.appendChild(linkElement);
        linkElement.click();
        this.exportandoGeneros = false;
      })
      .catch((error: any) => {
        this.exportandoGeneros = false;
        console.error(error);
      });
  }

  gerarTrocas() {
    this.exportandoTrocas = true;
    Service.gerarTrocas()
      .then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const linkElement = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('download', response.headers['content-disposition'].split('=')[1]);
        linkElement.setAttribute('href', url);
        document.body.appendChild(linkElement);
        linkElement.click();
        this.exportandoTrocas = false;
      })
      .catch((error: any) => {
        this.exportandoTrocas = false;
        console.error(error);
      });
  }

  gerarQtdProdutoPorLoja() {
    this.exportandoQtdProdutoPorLoja = true;
    Service.gerarQtdProdutoPorLoja()
      .then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const linkElement = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('download', response.headers['content-disposition'].split('=')[1]);
        linkElement.setAttribute('href', url);
        document.body.appendChild(linkElement);
        linkElement.click();
        this.exportandoQtdProdutoPorLoja = false;
      })
      .catch((error: any) => {
        this.exportandoQtdProdutoPorLoja = false;
        console.error(error);
      });
  }
}
